// Listen for the Escape key while `active` is true and fire onEscape.
// Use this for modals/popovers that don't already handle Escape internally
// (Radix Dialog handles it for us; our hand-rolled modals do not).

import { useEffect } from 'react';

export function useEscapeKey(active: boolean, onEscape: () => void): void {
  useEffect(() => {
    if (!active) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        // Stop the event reaching page-level Escape listeners (e.g. JobDetailPage's
        // window keydown that navigates back to /jobs). Without this, closing a
        // hand-rolled modal also triggered the page navigation. Plain
        // stopPropagation (not stopImmediate) is safe: only one of these hook
        // listeners is ever active at a time — the single stacking case
        // (CalendarDayDetailModal) disables its own handler while an inner modal
        // is open.
        e.stopPropagation();
        onEscape();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [active, onEscape]);
}
